import { FunctionComponent } from 'react';

import { Box as RadixBox, BoxProps } from '@radix-ui/themes';

export const Box: FunctionComponent<BoxProps> = (props: BoxProps) => {
  return <RadixBox {...props} />;
};
